import { statusRecipe } from '../constants/recipe-status.constant';

export const recipeStatus = (status, prescryption_type) => {
	if (prescryption_type === statusRecipe.NP) {
		return 'N/A';
	}
	if (!status) {
		return 'Receta por aprobar';
	}

	return statusRecipe[status];
};
